import { Box, Button, Input, Spinner } from '@chakra-ui/react';
import { ethers } from 'ethers';
import { useEffect, useState } from 'react';
import { PanelGroup } from 'src/pages/GameOverview/Body/panelGroup';
import { TOKEN_ABI } from 'src/pages/GameOverview/GetGame/abis';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { OPENER_ABI } from './ABI';

const OPENER_ADDRESS = '0x71db4E029C6EEf39bc98ca0A92719B600830Db25';

export const OpenPackage = ({ address }: { address: string }) => {
	const { callToActionColor } = useGameColorsProvider();

	const [loading, setLoading] = useState<boolean>(false);
	const [isValidEmail, setIsValidEmail] = useState<boolean>(false);
	const [email, setEmail] = useState<string>('');
	const [error, setError] = useState<string>('');
	const [success, setSuccess] = useState<boolean>(false);

	const { isEthereum, login, isLoggedIn, signer, account, provider, isChainValid } = useBlockchainProvider();

	const handleOpen = async () => {
		setLoading(true);
		setSuccess(false);
		setError('');

		if (!isLoggedIn) {
			setError('You login to open package.');
			return;
		} else if (!isChainValid) {
			setError('Invalid chain selected.');
			return;
		}

		const openerContract = new ethers.Contract(OPENER_ADDRESS, OPENER_ABI, signer!);

		openerContract
			.openPackage(address, email)
			.then(() => {
				setSuccess(true);
				setLoading(false);
				setEmail('');
			})
			.catch((e: any) => {
				console.log(e);
				setLoading(false);
				setError('Something went wrong. Try again later.');
			});
	};

	const validateEmail = (v: string) => {
		return String(v)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
	};

	useEffect(() => {
		setIsValidEmail(validateEmail(email) ? true : false);
	}, [email]);

	return (
		<PanelGroup>
			<Box mb="4px">Your email address</Box>
			<Input
				type="email"
				onChange={e => setEmail(e.target.value)}
			/>
			<Button
				mt="20px"
				h="60px"
				disabled={!isValidEmail}
				bgColor={callToActionColor}
				onClick={handleOpen}
			>
				{!loading ? 'Open the key' : <Spinner />}
			</Button>
			{error && (
				<Box
					mt="6px"
					color="red"
				>
					{error}
				</Box>
			)}
			{success && (
				<Box
					mt="4px"
					color="green"
				>
					Your key will be sent to your email.
				</Box>
			)}
		</PanelGroup>
	);
};
